import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

import STYLES from './EndTip.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  className?: Maybe<string>;
  i18n: I18nService;
};

const cls = cssModules(STYLES);

const EndTip = ({ className, i18n }: Props) => (
  <div className={cls('EndTip', className)}>{i18n.translate('Page_end')}</div>
);

export default withI18n(EndTip);
